/* English dictionary: packs namespace. See src/i18n/README.md. */

import type { TextSpec } from '../text';

const packs = {
  // ---- Lore section headings (core/lore.ts LORE_SECTIONS) ----
  'lore.section.effect': [ 'Effect' ],
  'lore.section.strategy': [ 'Strategy' ],
  'lore.section.counter': [ 'Counterplay' ],
  'lore.section.combo': [ 'Combos' ],
  'lore.section.hint': [ 'How to' ],

  // ---- Reusable terms in lore (core/lore.ts LORE_TERMS) ----
  'lore.term.nearDeath': [ 'near-death' ],
  'lore.term.lethal': [ 'lethal' ],
  'lore.term.rescue': [ 'rescue' ],
  'lore.term.interrupt': [ 'interrupt' ],
  'lore.term.turn': [ 'turn' ],
  'lore.term.drawPile': [ 'draw pile' ],
  'lore.term.discardPile': [ 'discard pile' ],
  'lore.term.hand': [ 'hand' ],
  'lore.term.combo': [ 'combo' ],
  'lore.term.pair': [ 'pair' ],
  'lore.term.triple': [ 'three of a kind' ],
  'lore.term.fiveDifferent': [ 'five different cards' ],

  // ---- Extra combo rules shown on powerless cards (gated by room rules) ----
  'lore.combo.pair.title': [ 'Effect: Pair' ],
  'lore.combo.pair.body': [ 'Play any ', { type: 'term', term: 'pair' }, ' of matching cards, name a player, and draw one card from that player’s hand.' ],
  'lore.combo.triple.title': [ 'Effect: Three of a Kind' ],
  'lore.combo.triple.body': [ 'Play any ', { type: 'term', term: 'triple' }, ' to make a player hand over a card you name.\n(If the opponent does not have that card, nothing happens.)' ],
  'lore.combo.fiveDifferent.title': [ 'Effect: Five Different' ],
  'lore.combo.fiveDifferent.body': [ 'Play any ', { type: 'term', term: 'fiveDifferent' }, ' to take any card from the discard pile.\nThis also applies to action cards: you may forgo their original effect and use them for the combo.' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
packs satisfies Record<string, TextSpec>;
export default packs;
